var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArSlotPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7645",
    "data-name": "Group 7645",
    transform: "translate(12728 -10210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_22125",
    "data-name": "Ellipse 22125",
    transform: "translate(-12728 10210)",
    fill: "#fff",
    stroke: "#4f5b6d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5243",
    "data-name": "Path 5243",
    d: "M4.91,4.432a1.031,1.031,0,0,1,.946-1.092H9.01A3.117,3.117,0,0,1,12.3,6.264a1.819,1.819,0,0,1,0,.364A3.1,3.1,0,0,1,9.386,9.9H7.033v2.547a1.067,1.067,0,0,1-2.122,0Zm2.122.788V8.034h1.88a1.346,1.346,0,0,0,1.213-1.407A1.322,1.322,0,0,0,8.913,5.221Z",
    transform: "translate(-12728.283 10209.664)",
    fill: "#4f5b6d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArSlotPartner);
export default __webpack_public_path__ + "static/media/ar-slot-partner.a095b714dc26e3fa7ab193908d2b782b.svg";
export { ForwardRef as ReactComponent };